import React from "react";
import PropTypes from "prop-types";

import { Field, Control } from "rbx";
import { GLMainAccountSelect } from "../../inputs";

function LocationParameterInputs({
  RevGLRecIdRef,
  ArGLRecIdRef,
  InvGLRecIdRef,
  CogsGLRecIdRef,
  onChange,
  codeStates
}) {
  return (
    <React.Fragment>
      <hr style={{ backgroundColor: "#ddd" }} />
      <Field kind="group">
        <h1 style={{ fontSize: "1.5rem" }}>GL Accounts</h1>
      </Field>
      <Field kind="group">
        <Control expanded>
          <GLMainAccountSelect
            label="Revenue"
            name="RevGLRecIdRef"
            value={RevGLRecIdRef}
            where={{
              TypeRecIdRef: codeStates.revenue.RecId
            }}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <GLMainAccountSelect
            label="Accounts Receivable"
            name="ArGLRecIdRef"
            value={ArGLRecIdRef}
            where={{
              TypeRecIdRef: codeStates.asset.RecId
            }}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <GLMainAccountSelect
            label="Inventory"
            name="InvGLRecIdRef"
            value={InvGLRecIdRef}
            where={{
              TypeRecIdRef: codeStates.asset.RecId
            }}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <GLMainAccountSelect
            label="Cost of Goods Sold"
            name="CogsGLRecIdRef"
            value={CogsGLRecIdRef}
            where={{
              TypeRecIdRef: codeStates.expense.RecId
            }}
            onChange={onChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}

LocationParameterInputs.propTypes = {
  RevGLRecIdRef: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ArGLRecIdRef: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  InvGLRecIdRef: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  CogsGLRecIdRef: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  codeStates: PropTypes.object
};

export default LocationParameterInputs;
